import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const testimonial = {
  content:
    "Square Trigger helped improve our website structure and digital visibility. Their process was clear, professional, and focused on results.",
  author: "Einsured.ca",
};

export const TestimonialsSection = () => {
  return (
    <section className="pt-8 sm:pt-10 lg:pt-12 pb-12 sm:pb-14 lg:pb-16 bg-muted/30 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 left-10 w-72 h-72 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute -bottom-24 right-10 w-72 h-72 bg-secondary/5 rounded-full blur-3xl" />
      </div>

      <div className="container-custom relative z-10">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-10 sm:mb-14"
        >
          <span className="text-sm font-medium text-primary uppercase tracking-wider">
            Testimonials
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-foreground mt-3 mb-4 sm:mb-6">
            What Our <span className="gradient-text">Clients Say</span>
          </h2>
        </motion.div>

        {/* Single Testimonial */}
        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Quote Icon */}
            <div className="absolute -top-7 left-4 sm:left-0 w-14 h-14 sm:w-16 sm:h-16 rounded-full gradient-primary-soft flex items-center justify-center">
              <Quote className="h-7 w-7 sm:h-8 sm:w-8 text-primary" />
            </div>

            {/* Card */}
            <div className="bg-card rounded-2xl border border-border p-6 sm:p-8 md:p-12 shadow-soft flex items-center">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
                className="w-full text-center sm:text-left"
              >
                <p className="text-base sm:text-lg md:text-xl text-foreground leading-relaxed">
                  “{testimonial.content}”
                </p>

                <div className="mt-6 sm:mt-8 text-foreground/80 font-semibold text-center sm:text-left">
                  — {testimonial.author}
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};